import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./assets/css/margins-paddings.css";
// import Version01 from "./components/pages/version-01";
import Version02 from "./components/pages/version-02";
// import Version03 from "./components/pages/version-03";
// import Version04 from "./components/pages/version-04";
// import Version05 from "./components/pages/version-05";
// import Version06 from "./components/pages/version-06";

import AOS from "aos";
import { useEffect } from "react";
import "./assets/css/aos.css";
import AllBlog from "./components/pages/all-blog";
import AllEvent from "./components/pages/all-event";
import BlogLeftSidebar from "./components/pages/blog-left-sidebar";
import BlogRightSidebar from "./components/pages/blog-right-sidebar";
import SingleBlog from "./components/pages/single-blog";
import SingleEvent from "./components/pages/single-event";
import footerData from "./data/footer.json";
import headerData from "./data/header.json";

// Admin imports
import { AuthProvider } from "./hooks/useAuth";
import { SiteDataProvider } from "./context/SiteDataContext";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import SectionsList from "./components/admin/SectionsList";
import SectionEditor from "./components/admin/SectionEditor";
import TestimonialsList from "./components/admin/TestimonialsList";
import ContactEditor from "./components/admin/ContactEditor";
import PricingEditor from "./components/admin/PricingEditor";
import AuthorEditor from "./components/admin/AuthorEditor";
import ServiceDeRelectureEditor from "./components/admin/ServiceDeRelectureEditor";
import ProtectedRoute from "./components/admin/ProtectedRoute";

function ScrollToTop() {
  const { pathname } = useLocation();
  
  // Clear hash immediately on mount (before any scroll can happen)
  useEffect(() => {
    // Clear hash from URL immediately
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    
    // Scroll to top immediately
    window.scrollTo(0, 0);
    
    // Also scroll after a short delay to override any react-scroll behavior
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
    
    return () => clearTimeout(timer);
  }, [pathname]);

  // Also clear hash on initial page load (outside of useEffect for immediate execution)
  useEffect(() => {
    if (window.location.hash && pathname === '/') {
      window.history.replaceState(null, '', '/');
      window.scrollTo(0, 0);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
function App() {
  const { header, headerv3 } = headerData;
  const { footer } = footerData;
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <AuthProvider>
      <SiteDataProvider>
    <div className="section-wrapper">
      <div id="preLoader" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
            {/* Public routes */}
          <Route path="/" element={<Version02 header={header} footer={footer} />} />
          {/* <Route path="v1" element={<Version01 header={header} footer={footer} />} />
          <Route path="v2" element={<Version02 header={header} footer={footer} />} />
          <Route path="v3" element={<Version03 header={header} footer={footer} />} />
          <Route path="v4" element={<Version04 headerv2={headerv2} footer={footer} />} /> */}
          {/* <Route path="v5" element={<Version05 headerv2={headerv2} footer={footer} />} />
          <Route path="v6" element={<Version06 headerv2={headerv2} footer={footer} />} /> */}
          <Route
            path="single-blog"
            element={<SingleBlog headerv3={headerv3} footer={footer} />}
          />
          <Route path="all-blog" element={<AllBlog headerv3={headerv3} footer={footer} />} />
          <Route
            path="single-event"
            element={<SingleEvent headerv3={headerv3} footer={footer} />}
          />
          <Route path="all-event" element={<AllEvent headerv3={headerv3} footer={footer} />} />
          <Route
            path="blog-right-sidebar"
            element={<BlogRightSidebar headerv3={headerv3} footer={footer} />}
          />
          <Route
            path="blog-left-sidebar"
            element={<BlogLeftSidebar headerv3={headerv3} footer={footer} />}
          />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/sections" element={<ProtectedRoute><SectionsList /></ProtectedRoute>} />
            <Route path="/admin/sections/:id" element={<ProtectedRoute><SectionEditor /></ProtectedRoute>} />
            <Route path="/admin/author" element={<ProtectedRoute><AuthorEditor /></ProtectedRoute>} />
            <Route path="/admin/testimonials" element={<ProtectedRoute><TestimonialsList /></ProtectedRoute>} />
            <Route path="/admin/pricing" element={<ProtectedRoute><PricingEditor /></ProtectedRoute>} />
            <Route path="/admin/servicederelecture" element={<ProtectedRoute><ServiceDeRelectureEditor /></ProtectedRoute>} />
            <Route path="/admin/contact" element={<ProtectedRoute><ContactEditor /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
      </SiteDataProvider>
    </AuthProvider>
  );
}

export default App;
